const tableConstantsEN = {
  recordsSelected: 'Records Selected',
  total: 'Total',
  records: 'Records',
  filter: 'Filter',
};

export default tableConstantsEN;
